import src from "IMAGE";
export default { src, width: 2405, height: 240, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAMHDxUKCwwWLSEkPFA5RGUdDBYxOhoWTR0pL3g9QkF0RgwFjjFDsmEAAAAASUVORK5CYII="};
